var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.dialogVisible) ? _c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "margin-top": "40px",
      "margin-left": "40px",
      "font-weight": "600"
    }
  }, [_vm._v("工资占比表")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "9px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "#FFFFFF",
      "margin": "0px 40px",
      "border": "1px solid #eaebed"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding-left": "46px",
      "padding-top": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('span', [_vm._v("日期")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "month",
      "placeholder": "请选择",
      "value-format": "yyyy-MM"
    },
    model: {
      value: (_vm.condition.years_date),
      callback: function($$v) {
        _vm.$set(_vm.condition, "years_date", $$v)
      },
      expression: "condition.years_date"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Find
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t查询")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": function($event) {
        return _vm.openfileUrl()
      }
    }
  }, [_vm._v("导入")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "导入",
      "visible": _vm.dialogVisibledr,
      "width": "30%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibledr = $event
      },
      "close": _vm.closeDialog
    }
  }, [_c('el-upload', {
    ref: "adModel",
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$globals.http + '/file/upload',
      "multiple": "",
      "file-list": _vm.fileList,
      "on-success": _vm.handleAvatarSuccess,
      "on-remove": _vm.handleRemove
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t选择文件")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [(_vm.fileDatatitle) ? _c('div', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("导入失败项目名单：\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-start",
      "flex-wrap": "wrap"
    }
  }, _vm._l((_vm.fileData), function(item, index) {
    return _c('div', {
      staticStyle: {
        "flex": "1",
        "width": "calc((100% - 20px) / 5)",
        "min-width": "calc((100% - 20px) / 5)",
        "max-width": "calc((100% - 20px) / 5)"
      }
    }, [_c('div', [_vm._v(_vm._s(item))])])
  }), 0)]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "background-color": "#006E4B",
      "border": "1px solid #006E4B",
      "margin": "30px 0 0 40%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.savefileUrl()
      }
    }
  }, [_vm._v("确 定")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('download-excel', {
    staticClass: "export-excel-wrapper",
    attrs: {
      "fields": _vm.download_excel,
      "name": "工资占比表",
      "fetch": _vm.ExportForm
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t导出")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "0px 2%",
      "margin-top": "10px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#d3eae2',
        color: '#000000'
      },
      "border": true,
      "data": _vm.tabledatas,
      "height": "570",
      "tooltip-effect": "dark",
      "row-class-name": _vm.tableRowClassName,
      "expand-row-keys": _vm.expands
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "select-all": _vm.handleSelectAll,
      "expand-change": _vm.handleSelect
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand",
      "fixed": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-table', {
          ref: "table",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "header-cell-style": {
              background: '#edeff1',
              color: '#000000'
            },
            "border": true,
            "data": _vm.childTable,
            "height": "400",
            "tooltip-effect": "dark"
          },
          on: {
            "selection-change": _vm.handleSelectionChanges,
            "select": _vm.handleSelects
          }
        }, [_c('el-table-column', {
          attrs: {
            "align": "center",
            "label": "序号",
            "width": "50"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope_1) {
              return [_vm._v(_vm._s(scope_1.$index + 1))]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "organize_name",
            "align": "center",
            "label": "支援项目名"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "number_of_investors",
            "align": "center",
            "label": "开资人数"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "payroll_payable",
            "align": "center",
            "label": "工资表应发工资"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "payroll_actual_salary",
            "align": "center",
            "label": "工资表实发工资"
          }
        })], 1)]
      }
    }], null, false, 3742084392)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "width": "55",
      "fixed": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }], null, false, 1273622649)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organize_name",
      "align": "center",
      "label": "项目名称",
      "width": "200",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "收入"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "actual_estimate_name",
      "align": "center",
      "label": "是否开票",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-right": "10px"
          },
          attrs: {
            "clearable": "",
            "size": "mini"
          },
          model: {
            value: (scope.row.actual_estimate),
            callback: function($$v) {
              _vm.$set(scope.row, "actual_estimate", $$v)
            },
            expression: "scope.row.actual_estimate"
          }
        }, _vm._l((_vm.lqList), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "value": item.value,
              "label": item.label
            }
          })
        }), 1), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.actual_estimate_name))])]
      }
    }], null, false, 175168691)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "开发票金额",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-left": "-5px",
            "width": "70px"
          },
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.invoiced_amount),
            callback: function($$v) {
              _vm.$set(scope.row, "invoiced_amount", $$v)
            },
            expression: "scope.row.invoiced_amount"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.invoiced_amount))])]
      }
    }], null, false, 835433143)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "开票明细",
      "width": "100"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "wage_quota",
      "align": "center",
      "label": "工资定额",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-left": "-5px",
            "width": "70px"
          },
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.wage_quota),
            callback: function($$v) {
              _vm.$set(scope.row, "wage_quota", $$v)
            },
            expression: "scope.row.wage_quota"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.wage_quota))])]
      }
    }], null, false, 2696684119)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "contract_amount",
      "align": "center",
      "label": "合同金额",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-left": "-5px",
            "width": "70px"
          },
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.contract_amount),
            callback: function($$v) {
              _vm.$set(scope.row, "contract_amount", $$v)
            },
            expression: "scope.row.contract_amount"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.contract_amount))])]
      }
    }], null, false, 425944599)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quota_proportion",
      "align": "center",
      "label": "定额占比",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.quota_proportion) + "%")])]
      }
    }], null, false, 216790165)
  })], 1)], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "工资明细"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "invoicing_shift",
      "align": "center",
      "label": "开发票班次",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-left": "-5px",
            "width": "70px"
          },
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.invoicing_shift),
            callback: function($$v) {
              _vm.$set(scope.row, "invoicing_shift", $$v)
            },
            expression: "scope.row.invoicing_shift"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.invoicing_shift))])]
      }
    }], null, false, 2328855703)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quota_difference",
      "align": "center",
      "label": "定额差额",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "number_of_investors",
      "align": "center",
      "label": "开资人数",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "substitute",
      "align": "center",
      "label": "替班",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "substitute_salary",
      "align": "center",
      "label": "代岗工资",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "payroll_payable",
      "align": "center",
      "label": "工资表应发工资",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "personal_part_of_social_security",
      "align": "center",
      "label": "社保个人部分",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accumulation_fund_deduction",
      "align": "center",
      "label": "公积金扣款",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accident_insurance_deduction",
      "align": "center",
      "label": "意外保险扣款",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clothing_deposit",
      "align": "center",
      "label": "服装押金",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "payroll_actual_salary",
      "align": "center",
      "label": "工资表实发工资",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "temporary_expenses",
      "align": "center",
      "label": "临勤费用",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-left": "-5px",
            "width": "70px"
          },
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.temporary_expenses),
            callback: function($$v) {
              _vm.$set(scope.row, "temporary_expenses", $$v)
            },
            expression: "scope.row.temporary_expenses"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.temporary_expenses))])]
      }
    }], null, false, 2311355671)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_expenses",
      "align": "center",
      "label": "总费用",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "actual_delivery_shift",
      "align": "center",
      "label": "实发班次",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-left": "-5px",
            "width": "70px"
          },
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.actual_delivery_shift),
            callback: function($$v) {
              _vm.$set(scope.row, "actual_delivery_shift", $$v)
            },
            expression: "scope.row.actual_delivery_shift"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.actual_delivery_shift))])]
      }
    }], null, false, 2874022199)
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "工资占比"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "proportion_wages",
      "align": "center",
      "label": "本月工资占比",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.proportion_wages) + "%")])]
      }
    }], null, false, 3360140172)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "previous_month_one",
      "align": "center",
      "label": "上月工资占比",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.previous_month_one) + "%")])]
      }
    }], null, false, 3461861549)
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "备注",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-left": "-5px",
            "width": "150px"
          },
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.remarks),
            callback: function($$v) {
              _vm.$set(scope.row, "remarks", $$v)
            },
            expression: "scope.row.remarks"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.remarks))])]
      }
    }], null, false, 3851184228)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "状态",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.spare5 === '0'),
            expression: "scope.row.spare5 === '0'"
          }],
          attrs: {
            "src": require("../../../assets/待审批.png")
          }
        }), _vm._v(" "), _c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.spare5 === '1'),
            expression: "scope.row.spare5 === '1'"
          }],
          attrs: {
            "src": require("../../../assets/已同意.png")
          }
        })]
      }
    }], null, false, 2927615228)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "150",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('button', {
          staticStyle: {
            "width": "50px",
            "background-color": "#006E4B",
            "color": "#FFFFFF",
            "border": "1px solid #006E4B",
            "border-radius": "5px"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('button', {
          staticStyle: {
            "width": "50px",
            "background-color": "#006E4B",
            "color": "#FFFFFF",
            "border": "1px solid #006E4B",
            "border-radius": "5px"
          },
          on: {
            "click": function($event) {
              return _vm.save(scope.$index, scope.row)
            }
          }
        }, [_vm._v("保存")])]
      }
    }], null, false, 3273082191)
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "0px 2%",
      "margin-top": "10px",
      "font-weight": "600"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', [_vm._v("总经理审批：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', [_vm._v("集团行政人资总监：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', [_vm._v("城市公司总经理审批：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', [_vm._v("行政经理：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', [_vm._v("制表：")])])], 1)], 1)], 1)], 1)], 1)])], 1) : _vm._e()])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87b05120","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gzhsgl/GzZb/GzZb.vue
// module id = null
// module chunks = 